import type { ComponentType } from '@angular/cdk/portal';
import { InjectionToken } from '@angular/core';

export interface LazyModal {
  loadComponent(): Promise<ComponentType<any>>;
  loadModule(): Promise<any>;
}

/**
 * Loader for a modal-routes registry. Providers must use a dynamic import so
 * the registry is only fetched on first modal open, keeping it out of the
 * initial bundle.
 */
export type LazyModalRoutes = () => Promise<{ [k: string]: LazyModal }>;

export const MODALS = new InjectionToken<LazyModalRoutes>('Modals');
